import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
const maxWidthClasses = {
    sm: 'max-w-2xl',
    md: 'max-w-4xl',
    lg: 'max-w-5xl',
    xl: 'max-w-7xl',
    full: 'max-w-full'
};
/**
 * PageContainer provides consistent padding and max-width for page content.
 *
 * @example
 * <PageContainer>
 *   <PageHeader title="My Page" />
 *   <PageSection>Content here</PageSection>
 * </PageContainer>
 *
 * @example
 * <PageContainer maxWidth="md">
 *   <p>Narrower content</p>
 * </PageContainer>
 */ export function PageContainer({ children, maxWidth = 'xl', className }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cn('p-6', maxWidthClasses[maxWidth], className),
        children: children
    });
}
